// src/pages/PokemonPond.jsx
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function PlayerShop() {
  return <GameMap config={mapConfigs.playerShop} />;
}